import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-page-sponsors',
  templateUrl: './event-page-sponsors.component.html',
  styleUrls: ['./event-page-sponsors.component.scss']
})
export class EventPageSponsorsComponent implements OnInit {

  @Input() eventPageConfig = null;
  @Input() eventPageData = null;
  
  public showSponsors = false;
  public sponsors: any = [];

  constructor() { }

  ngOnInit(): void {
    this.sponsors = this.eventPageData.sponsors;
    this.showSponsors = this.sponsors.length > 0 ? !this.eventPageConfig.hideSponsors: false;
  }

}
